import getCookieValue from "./getCookieValue";

const GetChatID = function (options) {
    return (
        (options.msg != null && options.msg.chatId) ||
        options.chatId ||
        getCookieValue('livechat_chat_id')
    );
};
export default GetChatID;
